var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 68,
    viewBox: "0 0 71 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_6",
    "data-name": "Polygon 6",
    d: "M46.47,0l.937,17.5L64.22,12.987,54.766,27.7,71,34,54.766,40.3,64.22,55.013,47.407,50.5,46.47,68,35.5,54.4,24.53,68l-.937-17.5L6.78,55.013,16.234,40.3,0,34l16.234-6.3L6.78,12.987,23.593,17.5,24.53,0,35.5,13.6Z",
    fill: "#f27022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.25c09fe435f7d4f68b94fce7434200d8.svg";
export { ForwardRef as ReactComponent };